import React from 'react';

import { useServices } from 'hooks/useServices';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { useQuery } from 'hooks/useQuery';

export const SignOutPage = () => {
  const { injectPromise } = useAsyncBoundary();

  const { signOut } = useServices();

  const dispatch = useAppDispatcher();

  const query = useQuery();

  const redirect = query.get('redirect');

  React.useEffect(() => {
    injectPromise(
      signOut().then(() => {
        dispatch({ name: 'SignOutPage__SignedOut' });

        if (redirect) {
          window.open(redirect, '_self');
        }
      })
    );
  }, [dispatch, injectPromise, redirect, signOut]);

  return null;
};
